export default class Toggler {

  constructor() {
    let _scope = this;

    this.toggler = document.querySelectorAll('.toggler-wrapper .toggler, .read-more');

    if(this.toggler.length) {
      for (let toggle of Array.from(this.toggler)) {
        _scope.init(toggle);
      }
    }
  }

  init(toggle) {
    let toggleHead = toggle.querySelectorAll('.toggle-head');
    let readMore = toggle.querySelectorAll('.read-more-link');

    if(toggleHead.length) {

      toggleHead[0].addEventListener('click', function (e) {
        if(toggle.classList.contains('opened')) {
          toggle.classList.remove('opened');
        } else {
          toggle.classList.add('opened');
        }
      });
    }

    if(readMore.length) {

      readMore[0].addEventListener('click', function (e) {
        if(toggle.classList.contains('opened')) {
          toggle.classList.remove('opened');
        } else {
          toggle.classList.add('opened');
        }
      });
    }
  }
}